import React, { Component } from "react"

import ScheduleTable from "../../../components/Table/ScheduleTable"
import SectionHeader from "../../../components/SectionHeader"
import rebase, { auth } from "../../../config/rebase"
import Wrapper from "../../../components/Common/Wrapper"
import { dbPrefix, userTypes } from "../../../Constants"
import { TextareaAutosize, Typography } from "@material-ui/core"
import CustomBtn from "../../../components/Buttons/CustomBtn"
import CustomCardItem from "../../../components/Cards/CustomCardItem"
import { server } from "../../../server"
import { hasSecondWaveBeenGenerated } from '../../../Constants';

class Users extends Component {

  state = {
    showEmails: false,
    users: [],
    emails: []
  }

  columns = [
    {
      name: "uName",
      label: "Nome",
      options: {
        filter: false
      }
    },
    {
      name: "uEmail",
      label: "Email",
      options: {
        filter: false
      }
    },
    {
      name: "type",
      label: "Tipo",
      options: {
        customBodyRender: (val) => {
          let t = userTypes.find(u => u.value === val).title
          return <span>{t}</span>
        }
      }
    },
  ]

  componentDidMount() {
    rebase.fetch(dbPrefix + 'users', {
      asArray: true,
    }).then(data => {
      const emails = data.filter(u => !u.staffAccount).map(u => u.uEmail)
      this.setState({ users: data, emails })
    }).catch(error => {
      console.log(error)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }).finally(() => {
      this.setState({ loaded: true })
    })
  }

  async createSecondWaveAccounts() {
    try {
      const secondWavers = this.state.users.filter(u => u.secondWave)

      for (const u of secondWavers) {
        const pass = u.ucpf.split("").reverse().join("")

        await auth.createUserWithEmailAndPassword(u.uEmail, pass)

        const data = {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: u.uEmail
          })
        }
        await fetch(server + '/accountCreated', data)
        console.log(`E-mail enviado para ${u.uEmail}`)
      }

      this.setState({ success: 'Notas atribuídas e e-mails enviados com sucesso' })
      alert("Ok. Deslogando...")
      window.location.href = "/logout"
    } catch (error) {
      this.setState({ error: "Ocorreu um erro.." })
    }
    finally {
      this.setState({ loaded: true })
    }
  }

  render() {

    return (

      <Wrapper success={this.state.success} loaded={this.state.loaded} fatalError={this.state.fatalError} currentPath={this.props.location.pathname} adminTopbar>
        <SectionHeader
          title="Usuários"
          subtitle="A tabela abaixo lista todos os usuários"
        />
        {!hasSecondWaveBeenGenerated && <CustomBtn onClick={this.createSecondWaveAccounts.bind(this)} title="Gerar contas para inscritos da segunda leva" />}
        {
          this.state.emails.length > 0 ? (
            <>
              <Typography>E-mails dos Participantes e Autores</Typography>
              <CustomBtn onClick={() => this.setState({ showEmails: !this.state.showEmails })} title={this.state.showEmails ? "Esconder" : "Ver"} />
              {this.state.showEmails &&
                <CustomCardItem>
                  <TextareaAutosize
                    rowsMin={10}
                    value={this.state.emails.join(", ")}
                    disabled
                    required
                  />
                </CustomCardItem>
              }
            </>
          )
            : null
        }
        <ScheduleTable data={this.state.users} columns={this.columns} title={"Usuários Cadastrados"} />
      </Wrapper>
    )
  }
}
export default Users
